import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone } from 'react-icons/fa';
import { MdMoreHoriz } from 'react-icons/md';
import './MoreStuff.css';

function MoreStuff() {
  return (
    <section className="more-stuff">
      <div className="container">
        <h2><MdMoreHoriz className="section-icon" /> Some More Stuff</h2>
        <div className="more-stuff-links">
          <Link to="/telephony" className="more-stuff-link">
            <FaPhone className="icon" />
            <span>Telephony Stuff</span>
            <span className="more-stuff-link-desc">A collection of various Telstra PSTN RVAs, Telstra/Optus Hold Music and other random telephony stuff</span>
          </Link>
        </div>
      </div>
    </section>
  );
}

export default MoreStuff;
